import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import Store from './redux';
import Routes from './routes';
import { ConfigProvider } from 'antd';
import ptBR from 'antd/lib/locale/pt_BR';
import { ToastContainer } from 'react-toastify';
import 'antd/dist/antd.css';
import { GlobalStyle } from './styles/global';
import 'bootstrap/dist/css/bootstrap.min.css';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={Store}>
      <ConfigProvider locale={ptBR}>
        <Routes />
        <ToastContainer autoClose={3000}></ToastContainer>
        <GlobalStyle />
      </ConfigProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root'),
);
